import { TAB_VIEW_HEADER_ORDER } from "../constants";
import { PATCH_PARAMS, POST_PARAMS, GET_PARAMS } from "./paramHelper";

export const RECEIVE_FEEDS = "RECEIVE_FEEDS";
export const RECEIVE_FEED = "RECEIVE_FEED";
export const FEED_CREATION_ERROR = "FEED_CREATION_ERROR";
export const FEED_UPDATE_ERROR = "FEED_UPDATE_ERROR";
export const FEED_NOT_FOUND = "FEED_NOT_FOUND";

export const fetchFeeds = (token) => async (dispatch) => {
  return await fetch("/api/reports", GET_PARAMS(token)).then(
    async (response) => {
      let { reports } = await response.json();
      reports = reports.filter(
        (r) => TAB_VIEW_HEADER_ORDER.indexOf(r.type) > -1
      );
      return dispatch({
        type: RECEIVE_FEEDS,
        feeds: reports,
      });
    }
  );
};

export const fetchFeed = (id) => async (dispatch) => {
  try {
    const response = await fetch(`/api/reports/${id}`, GET_PARAMS());

    if (!response.ok) {
      const json = await response.json();
      throw new Error(json.error);
    }

    const { report } = await response.json();

    return dispatch({ type: RECEIVE_FEED, feed: report });
  } catch (error) {
    return dispatch({ type: FEED_NOT_FOUND, error: "Feed doesn't exist" });
  }
};

export const updateFeed = (id, body) => async (dispatch) => {
  try {
    const response = await fetch(
      `/api/reports/${id}`,
      PATCH_PARAMS({ report: body })
    );

    if (!response.ok) {
      const json = await response.json();
      throw new Error(json.error);
    }

    const json = await response.json();

    return dispatch({ type: RECEIVE_FEED, feed: json.report });
  } catch (error) {
    return dispatch({ type: FEED_UPDATE_ERROR, error: error.message });
  }
};

export const updateFeedServiceStop = (id, serviceStop) => async (dispatch) => {
  // We shouldn't give the ability to update _any_ field for a feed, thus this
  // action gives us the ability to start / stop a feed by updating the service_stop
  // but isn't a traditional patch input that allows an update to any field
  try {
    const response = await fetch(
      `/api/reports/${id}`,
      PATCH_PARAMS({ report: { service_stop: serviceStop } })
    );

    if (!response.ok) {
      const json = await response.json();
      throw new Error(json.error);
    }

    const json = await response.json();

    return dispatch({ type: RECEIVE_FEED, feed: json.report });
  } catch (error) {
    return dispatch({ type: FEED_UPDATE_ERROR, error: error.message });
  }
};

export const createFeed = (feed) => async (dispatch) => {
  try {
    const response = await fetch("/api/reports", POST_PARAMS({ report: feed }));

    if (!response.ok) {
      const json = await response.json();
      throw new Error(json.error);
    }

    const json = await response.json();

    if (Array.isArray(json.report)) {
      return dispatch({
        type: RECEIVE_FEEDS,
        feeds: json.report,
        successMessage: json.successMessage,
      });
    }
    return dispatch({
      type: RECEIVE_FEED,
      feed: json.report,
      successMessage: json.successMessage,
    });
  } catch (error) {
    return dispatch({ type: FEED_CREATION_ERROR, error: error.message });
  }
};
